import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../components/Flex";
import MicroTextArea from "../../../../../../../../../../components/MicroTextArea";
import CustomTitle from "../../../../../../../../../../components/app/CustomTitle";
import ClinicalActions from "./ClinicalActions";
import ClinicalPreview from "./ClinicalPreview";

interface Props {
  formik?: FormikProps<any>;
}

const PsychiatricNoteSubjective = ({ formik }: Props) => {
  return (
    <>
      <ClinicalPreview />

      <Flex flexDirection="column" gap={1}>
        <CustomTitle>Allergies Free Note</CustomTitle>
        <MicroTextArea
          rows={4}
          variant="outlined"
          name="allergyFreeText"
          placeholder="Enter Allergies, ex:dust <press enter> food <press enter> animal dander ...etc"
          onBlur={formik?.handleBlur}
          value={formik?.values?.allergyFreeText ?? ""}
          onChange={formik?.handleChange}
        />
      </Flex>
      {/* add allergy, pmh, psh, fh, sh, current meds */}
      <ClinicalActions />
    </>
  );
};

export default PsychiatricNoteSubjective;
